import React from "react";
import { observer } from "mobx-react-lite";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { EventInsightsContent } from "./EventInsightsContent";

export const EventInsightsSection = observer(function EventInsightsSection() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store?.displayStatisticsGroup === StatisticsGroups.EventInsights) {
		return <EventInsightsContent store={store.sportStatisticsStore} />;
	}

	return null;
});
